import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, use } from "react";
import { SubmitHandler } from "react-hook-form";

import { NewsletterFormValues } from "../newsletter.schema";

type NewsletterContextValue = {
    buttonText: string;
    helperText: string;
    isBold: boolean;
    alignment: string;
    link: string;
    onFormSubmit: SubmitHandler<NewsletterFormValues>;
};

export type NewsletterContextProviderProps = {
    buttonText: string;
    helperText: string;
    isBold: boolean;
    alignment: string;
    link: string;
};

export const NewsletterContext = createContext<
    NewsletterContextValue | undefined
>(undefined);

NewsletterContext.displayName = "NewsletterContext";

export const NewsletterContextProvider = ({
    children,
    alignment,
    buttonText,
    helperText,
    isBold,
    link
}: RequireChildrenFor<NewsletterContextProviderProps>) => {
    const onFormSubmit = (form: NewsletterFormValues) => {
        location.assign(`${link}?email=${form.email}`);
    };

    return (
        <NewsletterContext
            value={{
                alignment,
                buttonText,
                helperText,
                isBold,
                link,
                onFormSubmit
            }}
        >
            {children}
        </NewsletterContext>
    );
};

export const useNewsletterContext = (): NewsletterContextValue => {
    const context = use<NewsletterContextValue | undefined>(NewsletterContext);
    if (!isDefined(context)) {
        throw new Error(`${NewsletterContext.displayName} is undefined.`);
    }
    return context;
};
